import React, { PropsWithChildren } from 'react';
import { RUMId } from './RUMElementId';

interface Props {
  id: RUMId;
}

const RUMEventTracking = ({ id, children }: PropsWithChildren<Props>) => {
  return <div id={id}>{children}</div>;
};

export default RUMEventTracking;
